export default __webpack_public_path__ + "static/media/icon_about.bcd45d18.svg";